export function flattenObject(object: Record<string, unknown>): Record<string, unknown> {
  const flattened: Record<string, unknown> = {};

  for (const prop in object) {
    if (!Object.prototype.hasOwnProperty.call(object, prop)) continue;

    if (typeof object[prop] === 'object' && object[prop] !== null) {
      const flatObject = flattenObject(object[prop] as Record<string, unknown>);
      for (const childProp in flatObject) {
        if (!Object.prototype.hasOwnProperty.call(flatObject, childProp)) continue;
        flattened[prop + '.' + childProp] = flatObject[childProp];
      }
    } else {
      flattened[prop] = object[prop];
    }
  }

  return flattened;
}
